/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';
import { FormattedDate, FormattedTime } from 'react-intl-next';

import { Stack, Text } from '@atlaskit/primitives/compiled';

interface TimestampProps {
	timestamp: string;
}

export const Timestamp = ({ timestamp }: TimestampProps): JSX.Element => {
	return (
		<Stack>
			<Text color="color.text.subtle">
				<FormattedDate value={timestamp} year="numeric" month="short" day="2-digit" />
			</Text>
			<Text color="color.text.subtlest">
				<FormattedTime
					value={timestamp}
					hourCycle="h23"
					hour="numeric"
					minute="numeric"
					timeZoneName="shortOffset"
				/>
			</Text>
		</Stack>
	);
};
